import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Application from 'flarum/common/Application';
import MobileTab from './components/MobileTab';

app.initializers.add('acpl/mobile-tab', () => {
  //@ts-ignore - missing 'mount' types
  extend(Application.prototype, 'mount', () => {
    const mTab = document.createElement('div');
    m.mount(document.body.appendChild(mTab), MobileTab);
  });

  // Apply DOM patches once the tab bar is rendered
  extend(MobileTab.prototype, 'oncreate', function () {
    const observer = new MutationObserver(() => {
      const container = document.querySelector('ul.MobileTab-items');
      if (!container) return;

      // 3) Rename any remaining "Tags" label to "Forums"
      const tagsLabel = Array.from(container.querySelectorAll('span.Button-label')).find(
        span => span.textContent?.trim() === 'Tags'
      );
      if (tagsLabel) {
        tagsLabel.textContent = 'Forums';
      }

      // 1) Force-show Notifications (remove any hiding; ensure dropdown works for logged-out)
      const notificationsLi = container.querySelector('li.item-notifications');
      if (notificationsLi) {
        notificationsLi.style.display = 'list-item';
        const link = notificationsLi.querySelector('a.Dropdown');
        if (link) {
          link.style.display = 'flex';
          // Ensure click opens login modal if logged out
          link.addEventListener('click', (e) => {
            if (!app.session.user) {
              e.preventDefault();
              app.modal.show(() => import('flarum/forum/components/LoginModal').then(m => m.default));
            }
          }, { once: true }); // one-time attach to avoid duplicates
        }
      }

      // 2) Add "Chat" button after "Forums" if not present
if (!container.querySelector('li.item-chat')) {
  const forumsLi = container.querySelector('li.item-tags');
  if (forumsLi) {
    const chatLi = document.createElement('li');
    chatLi.className = 'item-chat';

    const chatLink = document.createElement('a');
    chatLink.className = 'hasIcon';
    chatLink.setAttribute('aria-label', 'Chat');
    chatLink.href = '/p/1-real-time-chat';           // ← corrected relative path

    // Optional: add data attributes if your framework uses them for SPA routing
    // chatLink.dataset.navigate = 'true';

    const icon = document.createElement('i');
    icon.className = 'icon fas fa-comments Button-icon';
    icon.setAttribute('aria-hidden', 'true');

    const label = document.createElement('span');
    label.className = 'Button-label';
    label.textContent = 'Chat';

    chatLink.appendChild(icon);
    chatLink.appendChild(label);
    chatLi.appendChild(chatLink);

    // Insert after the forums/tags item
    forumsLi.insertAdjacentElement('afterend', chatLi);
  


          // Insert after Forums
          forumsLi.parentNode?.insertBefore(chatLi, forumsLi.nextSibling);
        }
      }

      // Optional: Disconnect observer once patched (performance)
      // observer.disconnect();
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });
});

export * from './components';
